/* globals Knitiv */

import Repre from '~/scripts/services/model/repre';

export default class FormSubmission {
	/**
	 * @param {Knitiv.FormSubmissionEntry | undefined} submission
	 */
	constructor(submission) {
		if (submission?.data) {
			// ==== convert data to array ====
			const aData = Array.isArray(submission.data)
				? submission.data
				: Object.entries(submission.data)
					.map(([key, values]) => ({
						key,
						values
					}));
			// ====

			this.data = Object.fromEntries(
				aData.map((/** @type {{ key: any; values: any; }} */ data) => [
					data.key,
					data.values
				]),
			);

			if ('KREPRE' in this.data) {
				// @ts-ignore
				this.data.KREPRE = this.data.KREPRE?.map(
					(/** @type {any} */ repre) => new Repre(repre),
				) ?? [];
			}
		}
		else {
			this.data = {};
		}

		this.files = submission?.files ?? [];
		this.kattribut = submission?.kattribut ??[];
		this.kdroit = submission?.kdroit ??[];
		this.kdroitcust = submission?.kdroitcust ??[];
		this.krepre = submission?.krepre ??[];
		this.params = submission?.params ??{};
		this.wf = submission?.wf ??[];
	}
}